import React from 'react';
import PropTypes from 'prop-types';
import DateTimeField from 'components/show/DateTimeField';
import FieldTitle from 'components/aor/FieldTitle';
import HeaderColumn from 'components/ui/table/HeaderColumn';
import NoResults from 'components/form/styling/NoResults';
import Table from 'components/ui/table/Table';
import TableBodyCell from 'components/table/TableBodyCell';
import TableRow from 'components/ui/table/TableRow';
import TextField from 'components/show/TextField';
import TimeField from 'components/show/TimeField';
import utils from 'helpers/utils';

const ProductReservationsList = (props) => {
    const {
        isDateRange,
        link,
        reservations,
        resource,
        source,
    } = props;

    if (utils.isEmpty(reservations)) {
        return <NoResults label={ `resources.products.occupancy.reservations.${ source }.no_results` } />;
    }

    const SourceComponent = isDateRange ? DateTimeField : TimeField;

    return (
        <Table responsive='scroll'>
            <TableRow>
                <HeaderColumn style={ { width: '33%' } }>
                    <FieldTitle
                        resource={ resource }
                        source={ source }
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '33%' } }>
                    <FieldTitle
                        resource={ resource }
                        source='full_name'
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '33%' } }>
                    <FieldTitle
                        resource={ resource }
                        source='license_plate'
                    />
                </HeaderColumn>
            </TableRow>

            {
                utils.map(reservations, (reservation) => {
                    const {
                        id,
                        reservation_data,
                    } = reservation;

                    const {
                        first_name,
                        last_name,
                        license_plate,
                    } = reservation_data;

                    return (
                        <TableRow key={ `reservation-${ id }` }>
                            <TableBodyCell
                                field={ <SourceComponent value={ reservation_data[source] } /> }
                                link={ link }
                                record={ reservation }
                                resource='reservations'
                                source={ source }
                            />

                            <TableBodyCell
                                field={ <TextField value={ utils.fullName(first_name, last_name) } /> }
                                link={ link }
                                record={ reservation }
                                resource='reservations'
                                source='full_name'
                            />

                            <TableBodyCell
                                field={ <TextField value={ license_plate || '' } /> }
                                link={ link }
                                record={ reservation }
                                resource='reservations'
                                source='license_plate'
                            />
                        </TableRow>
                    );
                })
            }
        </Table>
    );
};

ProductReservationsList.defaultProps = {
    isDateRange: false,
    link: 'show',
    resource: 'reservations',
};

ProductReservationsList.propTypes = {
    isDateRange: PropTypes.bool,
    link: PropTypes.string,
    reservations: PropTypes.arrayOf(PropTypes.object).isRequired,
    resource: PropTypes.string,
    source: PropTypes.oneOf([
        'destination_arrival_date',
        'destination_departure_date',
    ]).isRequired,
};

export default ProductReservationsList;


// WEBPACK FOOTER //
// ./src/pages/products/productOccupancy/reservations/list/ProductReservationsList.js